import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import QSpinnerDots from "../../node_modules/.pnpm/quasar@2.17.4/node_modules/quasar/src/components/spinner/QSpinnerDots.es.js";
import QSpinner from "../../node_modules/.pnpm/quasar@2.17.4/node_modules/quasar/src/components/spinner/QSpinner.es.js";
import { useTheming, Theme } from "@odin/services";
import WsCarySpinner from "./WsCarySpinner.vue.es.js";
import { SpinnerType } from "./WsSpinner.enum.es.js";
import { defineComponent, computed, openBlock, createElementBlock, createBlock, mergeProps, resolveDynamicComponent, createCommentVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { toDisplayString } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _hoisted_1 = { class: "ws-spinner" };
const _hoisted_2 = {
  key: 0,
  class: "text q-ml-md"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsSpinner",
  props: {
    spinnerType: {
      type: String,
      default: ""
    },
    width: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    height: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    color: {
      type: [String, void 0],
      required: false,
      default: void 0
    },
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const spinnerType = props.spinnerType;
    const { isTheme } = useTheming();
    const spinnerTypes = {
      [SpinnerType.CIRCULAR]: QSpinner,
      [SpinnerType.CARY]: WsCarySpinner,
      [SpinnerType.DOTS]: QSpinnerDots
    };
    const currentSpinner = computed(() => {
      if (spinnerType in spinnerTypes) {
        return spinnerTypes[spinnerType];
      } else if (isTheme(Theme.CARY)) {
        return WsCarySpinner;
      } else if (isTheme(Theme.LOOPIA) || isTheme(Theme.ACTIVE_24)) {
        return QSpinnerDots;
      } else {
        return QSpinner;
      }
    });
    const getSpinnerDefaultSize = computed(() => {
      if (spinnerType && spinnerType === SpinnerType.CIRCULAR || isTheme(Theme.ADMIN)) {
        return props.width || "24px";
      } else {
        return props.width || "80px";
      }
    });
    const getSpinnerColor = computed(() => {
      if (props.color) {
        return props.color;
      } else if (isTheme(Theme.CARY)) {
        return "dark";
      } else if (isTheme(Theme.LOOPIA)) {
        return "white";
      } else {
        return void 0;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(), createBlock(resolveDynamicComponent(currentSpinner.value), mergeProps(_ctx.$attrs, {
          width: getSpinnerDefaultSize.value,
          height: __props.height,
          color: getSpinnerColor.value
        }), null, 16, ["width", "height", "color"])),
        __props.text ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(_ctx.$t(__props.text)), 1)) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsSpinner.vue.es2.js.map
